import { AiShoppableImageError } from "./AiShoppableImageError";

export class FailedToFindPois extends AiShoppableImageError {}